import { Provider } from "react-redux";
import App from "./app/App";
import { createRoot } from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import "./app/assets/styles/index.scss";
import "pdfjs-dist/build/pdf.worker.entry";
import { PersistGate } from "redux-persist/integration/react";
import { persistor, store } from "./app/store/store";
import { pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
import { I18nextProvider } from "react-i18next";
import {
  createTheme,
  StyledEngineProvider,
  ThemeProvider,
} from "@mui/material/styles";
import { CssBaseline } from "@mui/material";
import i18n from "../public/i18n";

const container = document.getElementById("root");
const root = createRoot(container);

const theme = createTheme({
  typography: {
    fontFamily: "Montserrat",
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: 'Montserrat';
          font-style: bold;
          font-display: swap;
          font-weight: 700;
        }
      `,
    },
    MuiPopover: {
      defaultProps: {
        container: container,
      },
    },
    MuiPopper: {
      defaultProps: {
        container: container,
      },
    },
    MuiDialog: {
      defaultProps: {
        container: container,
      },
    },
    MuiModal: {
      defaultProps: {
        container: container,
      },
    },
  },
});

// In most use cases, we might want to delay the rendering of our app’s UI until the persisted
//data is available in the Redux store. For that, Redux Persist includes the PersistGate component.

root.render(
  <StyledEngineProvider injectFirst>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <I18nextProvider i18n={i18n}>
            <App />
          </I18nextProvider>
        </PersistGate>
      </Provider>
    </ThemeProvider>
  </StyledEngineProvider>
);

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/build/pdf.worker.min.js",
  import.meta.url
).toString();

reportWebVitals();
